<template>
  <div class="rounded-card bg-white border border-stone p-8 md:p-12">
    <div class="max-w-2xl mx-auto">
      <span class="inline-block rounded-badge bg-secondary text-primary text-xs font-medium tracking-label uppercase px-3 py-1">
        Birlikte Çalışalım
      </span>
      <h2 class="mt-6 text-3xl md:text-4xl font-medium text-primary tracking-display leading-[0.95]">
        Bloqin yolculuğunda yer al.
      </h2>
      <p class="mt-4 text-graphite text-base md:text-lg leading-relaxed">
        Advisory board üyeliği, stratejik ortaklık, gayrimenkul sponsorluğu veya farklı bir rolle
        Bloqin ekosistemine katkı sağlamak istiyorsan formu doldur. Kısa süre içinde dönüş yaparız.
      </p>

      <form @submit.prevent="submitForm" class="mt-10 grid grid-cols-1 md:grid-cols-2 gap-5">
        <div>
          <label for="app-name" class="block text-primary text-sm font-medium mb-2">
            Ad Soyad <span class="text-coral">*</span>
          </label>
          <input
            id="app-name"
            type="text"
            v-model="form.full_name"
            required
            placeholder="Adın ve soyadın"
            class="w-full px-4 py-3 rounded-btn bg-white text-primary placeholder:text-graphite border border-stone focus:outline-none focus:border-secondary"
          />
        </div>

        <div>
          <label for="app-email" class="block text-primary text-sm font-medium mb-2">
            E-posta <span class="text-coral">*</span>
          </label>
          <input
            id="app-email"
            type="email"
            v-model="form.email"
            required
            placeholder="seninadin@email.com"
            class="w-full px-4 py-3 rounded-btn bg-white text-primary placeholder:text-graphite border border-stone focus:outline-none focus:border-secondary"
          />
        </div>

        <div>
          <label for="app-phone" class="block text-primary text-sm font-medium mb-2">
            Telefon
          </label>
          <input
            id="app-phone"
            type="tel"
            v-model="form.phone"
            placeholder="+90 555 555 55 55"
            class="w-full px-4 py-3 rounded-btn bg-white text-primary placeholder:text-graphite border border-stone focus:outline-none focus:border-secondary"
          />
        </div>

        <div>
          <label for="app-org" class="block text-primary text-sm font-medium mb-2">
            Şirket / Kuruluş
          </label>
          <input
            id="app-org"
            type="text"
            v-model="form.organization"
            placeholder="Bağlı olduğun şirket veya kuruluş"
            class="w-full px-4 py-3 rounded-btn bg-white text-primary placeholder:text-graphite border border-stone focus:outline-none focus:border-secondary"
          />
        </div>

        <div class="md:col-span-2">
          <label for="app-role" class="block text-primary text-sm font-medium mb-2">
            İlgilendiğin rol <span class="text-coral">*</span>
          </label>
          <select
            id="app-role"
            v-model="form.role_interest"
            required
            class="w-full px-4 py-3 rounded-btn bg-white text-primary border border-stone focus:outline-none focus:border-secondary appearance-none"
          >
            <option value="" disabled>Bir seçenek seç</option>
            <option value="advisory_board">Advisory Board Üyeliği</option>
            <option value="strategic_partner">Stratejik Ortaklık</option>
            <option value="real_estate_sponsor">Gayrimenkul Sponsorluğu</option>
            <option value="technology_partner">Teknoloji Ortaklığı</option>
            <option value="legal_regulatory">Hukuk &amp; Regülasyon Danışmanlığı</option>
            <option value="institutional_investor">Kurumsal Yatırımcı</option>
            <option value="other">Diğer</option>
          </select>
        </div>

        <div class="md:col-span-2">
          <label for="app-message" class="block text-primary text-sm font-medium mb-2">
            Mesaj <span class="text-coral">*</span>
          </label>
          <textarea
            id="app-message"
            v-model="form.message"
            required
            rows="5"
            placeholder="Kendinden, deneyiminden ve Bloqin'e nasıl katkı sağlayabileceğinden bahset."
            class="w-full px-4 py-3 rounded-btn bg-white text-primary placeholder:text-graphite border border-stone focus:outline-none focus:border-secondary resize-none"
          ></textarea>
        </div>

        <div class="md:col-span-2 flex flex-col sm:flex-row items-stretch sm:items-center gap-4 pt-2">
          <button
            type="submit"
            class="inline-flex items-center justify-center px-6 py-4 rounded-btn border border-primary bg-secondary text-primary text-base font-medium hover:bg-primary hover:text-secondary transition-colors whitespace-nowrap disabled:opacity-60 disabled:cursor-not-allowed"
            :disabled="loading"
          >
            {{ loading ? 'Gönderiliyor…' : 'Talebi Gönder →' }}
          </button>
          <p class="text-graphite text-xs leading-relaxed">
            Gönderdiğin bilgiler yalnızca değerlendirme amacıyla kullanılır. KVKK kapsamında verilerin
            korunmaktadır.
          </p>
        </div>

        <div v-if="message" class="md:col-span-2">
          <p
            :class="success ? 'text-primary' : 'text-coral'"
            class="text-sm font-medium"
          >
            {{ message }}
          </p>
        </div>
      </form>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, reactive, ref } from 'vue';
import axios from 'axios';

const SUPABASE_URL = 'https://wehmgdcvztjpilyjasgz.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndlaG1nZGN2enRqcGlseWphc2d6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzg2NzgzNTUsImV4cCI6MjA5NDI1NDM1NX0.kpBvD1alcBTmLVHaLYtZ1TRN1QfMwwWNn1z-zlAwrP8';

export default defineComponent({
  name: 'ApplicationForm',
  setup() {
    const form = reactive({
      full_name: '',
      email: '',
      phone: '',
      organization: '',
      role_interest: '',
      message: '',
    });

    const loading = ref(false);
    const message = ref('');
    const success = ref(false);

    const isValidEmail = (value: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

    const submitForm = async () => {
      message.value = '';
      success.value = false;

      if (!form.full_name.trim() || !form.email.trim() || !form.role_interest || !form.message.trim()) {
        message.value = 'Lütfen zorunlu alanları doldur.';
        return;
      }

      if (!isValidEmail(form.email.trim())) {
        message.value = 'Lütfen geçerli bir e-posta gir.';
        return;
      }

      loading.value = true;

      try {
        await axios.post(
          `${SUPABASE_URL}/rest/v1/applications`,
          {
            full_name: form.full_name.trim(),
            email: form.email.trim().toLowerCase(),
            phone: form.phone.trim() || null,
            organization: form.organization.trim() || null,
            role_interest: form.role_interest,
            message: form.message.trim(),
            source: 'about_page',
          },
          {
            headers: {
              'Content-Type': 'application/json',
              apikey: SUPABASE_ANON_KEY,
              Authorization: `Bearer ${SUPABASE_ANON_KEY}`,
              Prefer: 'return=minimal',
            },
          }
        );

        message.value = 'Talebin alındı. Kısa süre içinde sana döneceğiz.';
        success.value = true;
        form.full_name = '';
        form.email = '';
        form.phone = '';
        form.organization = '';
        form.role_interest = '';
        form.message = '';
      } catch (error: any) {
        message.value = error.response?.data?.message || 'Bir hata oluştu. Lütfen tekrar dene.';
        success.value = false;
      } finally {
        loading.value = false;
      }
    };

    return { form, loading, message, success, submitForm };
  },
});
</script>
